<template>
  <div class="row items-center  my-msg justify-around full-width no-wrap">
    <div class="col-auto q-pa-xs">
      <div class="title">
        Finalize esse chat ou envie um novo template!
      </div>
      <div>
        Conversa fora da janela de 24h de atendimento ao cliente.
      </div>
    </div>

    <div class="col-auto">
      <ListBrokers
        size="18px"
        @on-template-select="handleStartChat"
      />
    </div>
  </div>
</template>

<script>
import ListBrokers from '@/components/ListBrokers'
import { startChat } from '@/libs/startAttendance'

export default {
  components: {
    ListBrokers
  },

  props: {
    attendance: {}
  },

  mounted () {
    this.$store.dispatch('agentModule/reloadSession')
  },

  methods: {
    handleStartChat (template) {
      const vm = this
      const templateId = template.id
      const destination = vm.attendance.sourceId
      startChat(vm, destination, templateId, template)
    }
  }
}

</script>

<style lang="sass" scoped>
.my-msg
  border: 1px solid red
  font-size: 12px
  border-radius: 4px
  color: #757575

  .title
    color: #263238
    font-weight: 600
    font-size: 16px
</style>
